import * as React from "react";

import { useFormikContext } from "formik";

import {
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import type { FormikInitialValuesNewRequest } from "../../../model/form.model";

import { CollapsibleSectionCard } from "../../components/CollapsibleSectionCard";
import { labelSx } from "../purchase/styles";

export function ObservationStepDesktop() {
  const { values, setFieldValue, handleBlur } = useFormikContext<
    FormikInitialValuesNewRequest
  >();

  const observationText = (values.observation.observationNote ?? "").trim();

  const preview = observationText ? (
    <Typography
      variant="body1"
      sx={{ color: "text.primary", fontSize: "1.6rem" }}
      noWrap
    >
      {observationText}
    </Typography>
  ) : null;

  return (
    <CollapsibleSectionCard
      title="Adicionar observação"
      collapsedTitle="Observação"
      defaultExpanded
      preview={preview}
    >
      <Stack spacing={2}>
        <TextField
          label="Observação"
          name="observation.observationNote"
          value={values.observation.observationNote}
          onChange={(e) =>
            setFieldValue("observation.observationNote", e.target.value)
          }
          onBlur={handleBlur}
          multiline
          minRows={5}
          maxRows={8}
          placeholder="Digite uma observação (opcional)"
          fullWidth
          sx={labelSx}
        />

        <FormControlLabel
          control={
            <Checkbox
              name="observation.commentsInInvoice"
              checked={values.observation.commentsInInvoice}
              onChange={(e) =>
                setFieldValue("observation.commentsInInvoice", e.target.checked)
              }
              onBlur={handleBlur}
            />
          }
          label={
            <Stack spacing={0.25}>
              <Typography sx={{ fontWeight: "bold" }}>
                Incluir observação na nota fiscal
              </Typography>
              <Typography variant="caption" sx={{ color: "text.primary" }}>
                A observação será impressa na NF-e
              </Typography>
            </Stack>
          }
        />
      </Stack>
    </CollapsibleSectionCard>
  );
}
